import { defineMessages } from 'react-intl.macro';

const messages = defineMessages({
    disabledLabBtnText: {
        id: 'labCard.disabledLabBtnText',
        description: 'button text in lab card when lab is disabled',
        defaultMessage: 'Unavailable',
    },
    enabledLabBtnText: {
        id: 'labCard.enabledLabBtnText',
        description: 'button text in lab card when lab is enabled',
        defaultMessage: 'Launch',
    },
});

export default messages;
